<template>
  <!-- 开票历史记录 -->
  <div class="myAbolishInvoicePage" v-if="!showLoad">
    <div class="abolishResonBox">
      <van-cell-group class="baseNone baseSalary beizhu">
        <p>作废原因：</p>
        <van-field
          v-model="invalidData.reason"
          clearable
          :readonly="!editType"
          :required="editType"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
          :placeholder="editType?'请输入...  ':''"
          type="textarea"
        />
      </van-cell-group>
    </div>

    <div class="kpList">
      <h4>发票信息</h4>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field v-model="fpData.num" readonly label="发票号：" input-align="right" class="ggInput" />
        <van-field
          :value="getfpName(fpData.type)"
          readonly
          label="发票类型："
          input-align="right"
          class="ggInput"
        />
        <van-field
          v-model="fpData.numAmount"
          readonly
          label="发票金额（元）："
          input-align="right"
          class="ggInput"
        />

        <van-field
          v-model="fpData.oppositeCompany"
          readonly
          label="单位："
          input-align="right"
          class="ggInput"
        />
        <van-field
          v-model="fpData.oppositeTallage"
          readonly
          label="税号："
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
    </div>
    <!-- 审批流程 -->
    <div class="approveList" v-if="this.mode != 'add' && invalidData.verifyStatus!='hold' ">
      <audit-list :applicantData="invalidData"></audit-list>
    </div>

    <!-- 流程图 -->
    <div class="flowList" v-if="this.mode != 'add' && invalidData.verifyStatus!='hold' ">
      <flow-staff :applicantData="invalidData"></flow-staff>
      <flow-list :workflowCode="invalidData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main :applicantData="invalidData" @changeVerifyType="setVerifyType"></verify-main>
    </van-popup>

    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode=='add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
      >提交</van-button>
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode!='verify'">
      <div class="btnBox editBtnbox clearfix" v-if="invalidData.verifyStatus=='hold'">
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
            >删除</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              class="btn"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
            >保存</van-button>
          </van-col>
        </van-row>
      </div>
      <div class="btnBox denyBtn clearfix" v-if="invalidData.verifyStatus=='deny'">
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
        >再次提交</van-button>
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="invalidData.verifyStatus=='pending' && mode != 'verify'  && sendType!='1'"
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
      >撤回修改</van-button>
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="(mode=='verify' && invalidData.verifyStatus=='pending'  &&  verifyType == '1') ||(mode=='verify' && invalidData.verifyStatus=='doing' &&  verifyType == '1') "
    >
      <van-button type="info" @click="verifyPage">{{verifyPageText}}</van-button>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
// import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage,is_wei} from "@/common/getDeviceType/getDeviceType";
import { dateFormat } from "@/utils/common";
export default {
  name: "myAbolishInvoice",
  data() {
    return {
      invoiceId: "", //发票Id
      commonId: "", //用户申请Id
      mode: "add",
      invalidData: {
        reason: "",
        verifyStatus: "hold",
      },
      fpData: {
        //发票信息
        id: "",
        num: "", //发票号
        numAmount: "", //发票金额，
        type: "", //发票类型，
        oppositeCompany: "", //单位名称，
        oppositeTallage: "", //税号，
      },
      abolishData: {
        invalidType: "exterior",
        makeInvoiceId: "",
        reason: "",
      },
      editType: false,
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      sendType: "", //判断是否在抄送列表
      clientType: getDeviceType(),
    };
  },
  mounted() {
    if(is_wei()){
      document.title="发票作废申请";
    }
    this.mode = this.$route.query.commonType; //// add:新增 edit:查看/编辑 verify 审批
    this.commonId = this.$route.query.commonId; //申请作废发票的申请Id
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
    window.editPage = this.editPage; //编辑页面
    this.initPage();
  },
  components: {
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      if (this.mode == "add") {
        this.invoiceId = this.$route.query.fpId; //发票Id
        this.$set(this.abolishData, "makeInvoiceId", this.invoiceId);
        this.getmakeInvoicelist(); //获取发票信息
      }

      if (this.mode !== "add") {
        this.$set(this.abolishData, "id", this.commonId);
        this.getDetails();
      }
    },
    verifyPage() {
      this.verifyPageType = true;
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    getDetails() {
      let _this = this;
      this.setShowLoad(false);
      _this.$api.finance.projectOpenTickets
        .getBadInvoice(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.invalidData = res.data;
            _this.fpData = res.data;
            this.$set(
              this.abolishData,
              "makeInvoiceId",
              res.data.makeInvoiceId
            );
            if (
              (_this.invalidData.verifyStatus == "hold" ||
                _this.invalidData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
            // _this.editPage();
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getmakeInvoicelist() {
      let _this = this;
      this.setShowLoad(false);
      _this.$api.finance.projectOpenTickets
        .getByMakeId(_this.invoiceId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.fpData = res.data;
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    checkInput() {
      if (this.invalidData.reason == "") {
        this.$toast("作废原因不能为空");
      } else {
        this.$set(this.abolishData, "reason", this.invalidData.reason);
        this.saveDelInvoice();
      }
    },
    getfpName(type) {
      let name = "";
      if (type == null) {
        name = "";
      } else if (type == "fapiao001") {
        name = "专票";
      } else {
        name = "普票";
      }
      return name;
    },
    saveDelInvoice() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.projectOpenTickets
        .addAbolishInvoice(_this.mode, _this.abolishData)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let text = "操作成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.invalidData.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.projectOpenTickets
            .delAbolishInvoice(
              _this.invalidData.verifyStatus,
              _this.invalidData.invalidId
            )
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        })
        .catch(() => {
          // on cancel取消删除操作
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.myAbolishInvoicePage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  padding-top: 10px;
  .abolishResonBox {
    p {
      width: 100%;
      padding: 0 16px;
      font-size: 15px;
      color: #323233;
    }
    .baseNone.beizhu::after {
      content: none;
    }
  }
  .baseNone.dwBox {
    .van-cell {
      .van-cell__title {
        width: 160px;
      }
    }
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #666;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 120px;
    .ggInput.van-cell {
      .van-cell__value {
        border: 1px solid #ebedf0;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        min-height: 150px;
        .van-field__control {
          text-align: left;
          color: #666;
          text-indent: 2em;
        }
      }
    }
    .ggInput.van-cell::after {
      content: none;
    }
    .ggInput.van-cell--required::before {
      top: -20px;
    }
  }
  .kpList {
    padding-top: 10px;
    h4 {
      position: relative;
      border-bottom: 1px solid #e0e0e0;
      line-height: 25px;
      padding: 0 25px;
      padding-right: 0;
      padding-bottom: 5px;
      font-weight: 700;
      color: #2581d6;
      font-size: 15px;
      z-index: 10;
      background-color: #fff;
    }
    h4:before {
      content: "";
      position: absolute;
      width: 5px;
      background: #2581d6;
      top: 0;
      left: 15px;
      bottom: 5px;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>